<!-- 日报表上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "bid": "",
                "in": "",
                "out": "",
                "exceptionIn": "",
                "exceptionOut": "",
                "incomeTempCash": "",
                "inComeTempApp": "",
                "incomeMonthCash": "",
                "incomeMonthApp": "",
                "date": ""
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报日报表信息",
                urlPattern:this.commonUrls.third+"reportDailyParkFee",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'bid', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'in', info2: '是', info3: 'Integer', info4: '进场数据' },
                        { info1: 'out', info2: '是', info3: 'Integer', info4: '出场数据' },
                        { info1: 'exceptionIn', info2: '是', info3: 'Integer', info4: '进场异常' },
                        { info1: 'exceptionOut', info2: '是', info3: 'Integer', info4: '出场异常' },
                        { info1: 'incomeTempCash', info2: '是', info3: 'Decimal', info4: '临停收入(现金收入,不包括app)' },
                        { info1: 'inComeTempApp', info2: '是', info3: 'Decimal', info4: '临停收入(APP收入)' },
                        { info1: 'incomeMonthCash', info2: '是', info3: 'Decimal', info4: '月卡收入(现金收入,不包括app)' },
                        { info1: 'incomeMonthApp', info2: '是', info3: 'Decimal', info4: '月卡收入(APP收入)' },
                        { info1: 'date', info2: '是', info3: 'String', info4: '日报时间,时间格式 YYYYMMDD' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportDailyParkFee.vue